import React from "react";
import { DropdownIcon } from "./components";
import styled from "styled-components";

const Destinations = ({ destinations }) => {
  return (
    <Container>
      Destinations
      <DropdownIcon right />
      <List>
        {destinations &&
          destinations.map(destination => (
            <DestinationContainer key={destination.country}>
              <CountryName>{destination.country}</CountryName>
              <StateContainer>
                {destination.cities.map(city => (
                  <ButtonLink key={city.name} href={city.url}>
                    {city.name}
                  </ButtonLink>
                ))}
              </StateContainer>
            </DestinationContainer>
          ))}
      </List>
    </Container>
  );
};
const List = styled.div`
  position: absolute;
  top: calc(100% + 2px);
  right: 0;
  z-index: 500;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  background-color: #fff;
  display: none;
`;

const DestinationContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;

  padding: 0.8rem;
`;
const CountryName = styled.h2`
  font-size: 1rem;
  color: #484848;
  margin: 0;
  font-weight: 400;
  width: 6rem;
`;
const StateContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;

  width: 20rem;
`;
const Container = styled.div`
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 0.5rem 0 0.2rem;
  border: 2px solid transparent;
  font-size: 0.875rem;
  &:hover {
    border-bottom-color: #33cc99;
  }
  &:hover ${List} {
    display: block;
  }
`;
export const ButtonLink = styled.a`
  font-size: 0.875rem;
  text-decoration: none;
  color: #484848;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 1.5rem;
  border-radius: 1rem;
  padding: 0 1.3rem;
  background-color: #fff;
  border: 1px solid #a0a0a0;

  margin: ${props => (props.navbar ? "0 1rem 0" : "0 0.2rem 0.4rem 0")};

  &:hover {
    text-decoration: none;
    background-color: #f7f7f7;
  }
`;
export default Destinations;
